module.exports = {
      id: "icon-episode-usage",
      viewBox: "0 0 25 25",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#icon-episode",
      toString: function () {
        return this.url;
      }
    }